import React, { useEffect, useState, useRef } from 'react';
import { SwitherComponent } from 'component/Swither';
import { ColorItem } from './ColorItem';

export const Legend = ({
  gridGeojson, setGridGeojson, methodTypes, map,
}) => {
  const [methodStates, setMethodStates] = useState({});
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current && gridGeojson?.features?.length > 0 && methodTypes?.length > 0) {
      const initialStates = {};
      methodTypes.forEach(method => {
        initialStates[Number(method.id)] = true;
      });
      setMethodStates(initialStates);
      isInitialized.current = true;
    }
  }, [gridGeojson, methodTypes]);

  const handleSwitcherChange = (checked, methodId) => {
    const numericMethodId = Number(methodId);

    const newMethodStates = {
      ...methodStates,
      [numericMethodId]: checked,
    };
    setMethodStates(newMethodStates);

    const visibleMethodIds = Object.keys(newMethodStates)
      .filter(id => newMethodStates[id] === true)
      .map(Number);
    const visibleColors = new Set(
      methodTypes
        .filter(method => visibleMethodIds.includes(Number(method.id)))
        .map(method => method.color)
    );

    const updatedFeatures = gridGeojson.features.map(feature => {
      const originalColors = Array.isArray(feature.properties.colors)
        ? feature.properties.colors
        : JSON.parse(feature.properties.colors || '[]');

      const render_colors = originalColors.filter(color => visibleColors.has(color));

      return {
        ...feature,
        properties: {
          ...feature.properties,
          render_colors: render_colors,
        },
      };
    });

    const newGeojson = {
      ...gridGeojson,
      features: updatedFeatures,
    };

    setGridGeojson(newGeojson);

    if (map && map.getSource('grid')) {
      map.getSource('grid').setData(newGeojson);
    }
    if (map && map.getSource('grid-counts')) {
      map.getSource('grid-counts').setData({ type: 'FeatureCollection', features: [] });
    }
  };

  if (!isInitialized.current) {
    return (
      <div className="legend">
        <div className="title">Legend</div>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="legend">
      <div className="title">Legend</div>
      {methodTypes?.map((method) => (
        <div className="legend-item" key={method?.id}>
          <SwitherComponent
            labelRight={(
              <div className="flex-group">
                <ColorItem color={method?.color} />
                <span>{method?.name}</span>
              </div>
            )}
            checked={methodStates[Number(method?.id)] !== false}
            handleSwitcher={(checked) => handleSwitcherChange(checked, Number(method?.id))}
          />
        </div>
      ))}
    </div>
  );
};